//
// https://stackoverflow.com/a/54292872/388351
//
import { useEffect, useRef } from 'react'
export function useOuterClick(callback) {
  var innerRef = useRef()
  var callbackRef = useRef()
  // set current callback in ref, before second useEffect uses it
  useEffect(function () {
    // useEffect wrapper to be safe for concurrent mode
    callbackRef.current = callback
  })
  useEffect(function () {
    document.addEventListener('click', handleClick)
    return function () {
      return document.removeEventListener('click', handleClick)
    }
    // read most recent callback and innerRef dom node from refs
    function handleClick(e) {
      if (
        innerRef.current &&
        callbackRef.current &&
        // @ts-ignore
        !innerRef.current.contains(e.target)
      ) {
        callbackRef.current(e)
      }
    }
  }, []) // no need for callback + innerRef dep
  return innerRef // return ref; client can omit `useRef`
}
//# sourceMappingURL=useOuterClick.js.map
